import { atom } from 'recoil';
import { EInfoModal, IInfoModal } from '@/components/ticketingNew/components/InfoModal';

export const ticketingCurrentLanguage = atom({
  key: 'ticketingCurrentLanguage',
  default: {} as any,
});

export const infoModalDataState = atom({
  key: 'infoModalDataState',
  default: {
    mode: EInfoModal.error,
    isOpen: false,
  } as IInfoModal,
});

export const redirectTicketsState = atom({
  key: 'redirectTicketsState',
  default: null as any,
});

export const orderedTicketsState = atom({
  key: 'orderedTicketsState',
  default: null as any,
});

export const ticketingDataState = atom({
  key: 'ticketingDataState',
  default: null as any,
});

export const bgImageState = atom({
  key: 'bgImageState',
  default: '',
});
